import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Slider, { SliderThumb } from '@mui/material/Slider'
import CircularSliderThumb from 'src/assets/circular_slider_thumb.svg'
import { getMPDataWithParams } from 'src/mentor/services'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { getListItemsFromWebinarsList } from 'src/business/views/Webinars/webinar-utils'
import { getListItemsForAssessments } from './AssessmentPlayerHelpers'
import { useNavigate } from 'react-router-dom'
import { EXTERNAL_FEATURE_TYPES } from 'src/consumer/constants'
import { getFeatureList } from 'src/consumer/services/featureServices'

const AssessmentStyledSlider = styled(Slider)(
  ({ theme }) => `
  color: #ECECEC;
  width: 90%;
  > .MuiSlider-thumb {
    height: 35px;
    width: 35px;
    padding: 0;
    background: transparent;
  };
  > .MuiSlider-markLabel {
    font-weight: 300;
    font-size: 10px;
    color: #505154;
    margin-top: 15px;
    font-family: Outfit;
    text-align: center;
    display: block; 
    width: 60px;
    white-space: pre-wrap;
  };
  > .MuiSlider-mark {
    background: #FFF;
    height: 10px;
    width: 10px;
    border: 1px solid #bfbfbf;
    border-radius: 50%;
  };
  > .MuiSlider-rail: {
    color: #ECECEC;
  };

  @media (min-width: 768px){
    > .MuiSlider-thumb {
      height: 55px;
      width: 55px;
      padding: 0;
      background: transparent;
    };
    > .MuiSlider-markLabel {
      font-weight: 300;
      font-size: 16px;
      color: #505154;
      margin-top: 15px;
      font-family: Outfit;
      text-align: center;
      display: block; 
      width: 100px;
      white-space: pre-wrap;
    };
    > .MuiSlider-mark {
      background: #FFF;
      height: 20px;
      width: 20px;
      border: 2px solid #bfbfbf;
      border-radius: 50%;
    };
  }

  @media (min-width: 1080px){
    width: 70%;
  }

`,
)

function AssessmentSliderThumb(props) {
  const { children, ...other } = props
  return (
    <SliderThumb {...other}>
      {children}
      <img src={CircularSliderThumb} style={{ width: '100%', height: '100%' }} alt="slider thumb" />
    </SliderThumb>
  )
}

export default function AssessmentStyledSelectionSliderComponent({
  optionsData,
  chosenAnswerIds,
  chosenComparative,
  updateFunction,
}) {
  const [sliderMarks, setSliderMarks] = useState([])
  const [value, setValue] = useState(50)

  const handleValueChange = (event, newValue) => {
    setValue(newValue)
    const selectedOptionData =
      optionsData?.[sliderMarks.findIndex((item) => item?.value === newValue)]
    if (selectedOptionData?.extraOption) {
      updateFunction('', '', [])
    } else {
      updateFunction(
        `${selectedOptionData?.[selectedOptionData?.comparative]} (${selectedOptionData?.name})`,
        selectedOptionData?.comparative,
        [selectedOptionData?.id],
      )
    }
  }

  useEffect(() => {
    const sliderMarksArray = optionsData?.map((optionItem, index) => {
      return {
        value: Math.floor(0 + index * (100 / (optionsData?.length - 1))),
        label: optionItem?.name,
      }
    })
    setSliderMarks(sliderMarksArray)
    if (chosenAnswerIds && chosenComparative && chosenAnswerIds?.length > 0) {
      setValue(
        sliderMarksArray?.[
          optionsData.findIndex(
            (item) => item?.comparative === chosenComparative && item.id === chosenAnswerIds?.[0],
          )
        ]?.value,
      )
    }
  }, [])

  return (
    <AssessmentStyledSlider
      value={value}
      onChange={handleValueChange}
      marks={sliderMarks}
      step={null}
      slots={{ thumb: AssessmentSliderThumb }}
      track={false}
      max={sliderMarks?.[sliderMarks?.length - 1]?.value}
    />
  )
}

export function APListingComponent({ domainIds = [], handleClose = () => {} }) {
  const [pageLoading, setPageLoading] = useState(false)
  const [webinarList, setWebinarList] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)
  const navigate = useNavigate()

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getFeatureList(EXTERNAL_FEATURE_TYPES.activityPlan)
    // const resp = await getMPDataWithParams(
    //   '/api/secure/entity/activity-plan/list/summary/open-to-all',
    //   {
    //     page: 1,
    //     domainIds: domainIds?.join(','),
    //   },
    // )
    if (resp?.status === 200) {
      setWebinarList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextWebinarPage() {
    const nextPageNumber = pageNumber + 1
    // const resp = await getMPDataWithParams('/api/secure/open-activity-plans/summary', {
    //   page: nextPageNumber,
    //   domainIds: domainIds?.join(','),
    // })
    const resp = await getFeatureList(EXTERNAL_FEATURE_TYPES.activityPlan, nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setWebinarList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextWebinarPage,
    rootMargin: '0px 0px 20px 0px',
  })

  function handlePlanClick(item) {
    navigate(`/plan/id/${item?.id}`)
  }

  useEffect(() => {
    pageSetup()
  }, [])
  return (
    <PublicListingComponentVarOne
      heading="Get a plan for yourself"
      // description="Explore Webinars"
      actionText="Start"
      listItemsArray={getListItemsForAssessments(webinarList)}
      sentryRef={sentryRef}
      hasNextPage={hasNextPage}
      onClickOverride={handlePlanClick}
      componentWrapperCustomStyles={{ padding: '0px !important' }}
    />
  )
}
